import { createGlobalStyle } from 'styled-components'

import UnicaseFontWoff from 'assets/fonts/Unicase/Webfonts/WOFF Unicase/SuzanoUnicase-Light.woff'
import UnicaseFontWoff2 from 'assets/fonts/Unicase/Webfonts/WOFF2 Unicase/SuzanoUnicase-Light.woff2'
import UnicaseFontEOT from 'assets/fonts/Unicase/Webfonts/EOT Unicase/SuzanoUnicase-Light.eot'

import TextFontWoff from 'assets/fonts/Text/Webfonts/WOFF Text/SuzanoText-Light.woff'
import TexFontWoff2 from 'assets/fonts/Text/Webfonts/WOFF2 Text/SuzanoText-Light.woff2'
import TexFontEOT from 'assets/fonts/Text/Webfonts/EOT Text/SuzanoText-Light.eot'
import TexFontTTF from 'assets/fonts/Text/Webfonts/TTF-WEB Text/SuzanoText-Light-web.ttf'
import TextFontWoffMedium from 'assets/fonts/Text/Webfonts/WOFF Text/SuzanoText-Medium.woff'
import TextFontWoffBold from 'assets/fonts/Text/Webfonts/WOFF Text/SuzanoText-Bold.woff'

const GlobalStyle = createGlobalStyle`


@font-face {
    font-family: 'Suzano Unicase';
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url(${UnicaseFontWoff}) format("woff"),
    url(${UnicaseFontWoff2}) format("woff2"),
    url(${UnicaseFontWoff2}) format('embedded-opentype');
}

@font-face {
    font-family: 'Suzano Text';
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url(${TextFontWoff}) format("woff"),
    url(${TexFontWoff2}) format("woff2"),
    url(${TexFontEOT}) format('embedded-opentype'),
    url(${TexFontTTF}) format('ttf'),
    url(${TextFontWoffMedium}) format("woff"),
    url(${TextFontWoffBold}) format("woff");
}


/* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #333333 #ffffff;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 10px;
  }

  *::-webkit-scrollbar-track {
    background: #ffffff;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #d6d6d6;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }
  
  .success-light {
    background: #c9e9da;
  }
  
  .warning-light {
    background: #e5ddcc
  }
  
  .btn-reload {
    position: absolute;
    top: 90px;
    left: 20px;
  }
  
  .header-page {
    font-family: 'Suzano Unicase';
    background-color: #4A2C31;
    color: white;
    padding: 10rem 6rem 5rem;
  }
  
  .header-page h1 {
    font-size: 3.5rem;
    width: 55%;
  }
  
  .header-tags {
    margin-top: 6rem;
  }
  
  .box-tag {
     font-family: "Suzano Text";
     letter-spacing: -0.02em;
     border: 1px solid #FFFFFF;
     padding: 0.5rem;
  }
  
  .box-tag p {
    font-weight: bold;
    margin-bottom: 0;
  }
  
  .body-page {
    background-color: #AEAB9E;
    color: #4A2C31;
    padding: 5rem 6rem;
  }
    
  .table-area table {
    background-color: #AEAB9E;
    color: #4A2C31;
  } 
  
  .table-area .table thead th,
  .table-area .table thead,
  .table-area .table tbody,
   .table-area .table tbody tr{
    border-color: #4A2C31;
  }
  
  .table-area .table tbody tr td,
   .table-area .table thead tr th{
    padding: 10px 8px;
    color: #4A2C31;
    background-color: #AEAB9E;
    vertical-align: middle;
    font-size: 0.875rem;
  }
  
  .table-area h4 {
    color: #4A2C31;
    font-size: 22px;
    font-family: "Suzano Text";
    font-weight: bold;
    margin-bottom: 20px;
  }
 
  .table-area .table-footer {
    margin: 30px 0 50px;
    color: #4A2C31;
    font-size: 14px;
    font-family: "Suzano Text";
    letter-spacing: -0.02em;
  }
  
  .table-area .table-footer ol, ul {
    padding-left: 1rem;
   }
   
   .table-area .form-select {
    background-color: #AEAB9E;
    border-color: #4A2C31;
    color: #4A2C31;
   }
   
   .preview-data .form-control:disabled, .form-control[readonly],
    .preview-data span .form-control, 
    .preview-data span.form-control.form-control-sm {
        background: transparent;
        text-align: right;
        color: #4A2C31;
   }
   
  
  .header-context {
   font-family: 'Suzano Unicase';
    border: 1px solid #4A2C31;
    text-transform: uppercase;
    font-size: 1.75rem;
    padding: 0.5rem;
    display: inline;
  }
  
  .body-text {
    font-family: 'Suzano Text';
    margin-top: 3rem;
    font-size: 1.25rem
  }
  
  .footer-page {
    background-color: #92714D;
    color: #FFFFFF;
    padding: 5rem 6rem;
  }
  
  .header-footer {
    font-family: 'Suzano Unicase';
    font-size: 1.75rem;
    text-transform: uppercase;
  }
  
  .text-footer {
    margin-top: 4rem;
    font-size: 1.25rem;
    border-top: 1px solid #FFFFFF;
    border-bottom: 1px solid #FFFFFF;
  }
  
  .text-footer p {
    font-family: 'Suzano Text';
    margin: 0;
  }
  
  .text-footer p a,
  .body-text p a {
    color: blue;
  }
  
  .ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable), .ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners {
    border: 1px solid #c6c6c6;
  }
  
  .form-check-custom.form-switch {
    display: flex;
    align-items: center;
  } 
  
  .form-check-custom.form-switch .form-check-input {
    width: 4em;
    height: 2em;
  }
  
  .form-check-custom.form-switch .form-check-label {
    font-size: 18px;
    padding: 0 10px;
  }
  
  .nav-sidebar .nav-item > .nav-link {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popover {
    z-index: 1050 !important;
    max-width: 380px !important;
}

.tooltip-inner {
    max-width: 400px !important;
}

.swal2-title {
    font-size: 1.35em !important;
}

.text-xs {
    font-size: 12px;
}

.text-sm {
    font-size: 14px;
}
  
`;

export default GlobalStyle;
